// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"view-module"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M2 20H22V4H2V20Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8.6665 4V20M15.333 4V20M2 12H22M2 20H22V4H2V20Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ViewModuleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'view-module',
    ref,
    icon: element,
  },
));

ViewModuleIcon.displayName = 'ViewModuleIcon';

export default ViewModuleIcon;
